import React, { ComponentProps, FC, ReactNode } from 'react';

import { Typography } from '@mui/material';

import TextWithTerms from '~/ui/components/TextWithTerms/TextWithTerms';

interface TypographyWithTermsProps extends ComponentProps<typeof Typography> {
  children?: ReactNode;
}

const TypographyWithTerms: FC<TypographyWithTermsProps> = ({ children, ...rest }) => {
  return (
    <Typography {...rest}>
      <TextWithTerms>{children}</TextWithTerms>
    </Typography>
  );
};

export default TypographyWithTerms;
